import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_BodyCardsRiddles.vue?vue&type=template&id=5ec897ff&scoped=true&"
import script from "./c_Creator_EditQuests_Item_BodyCardsRiddles.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_BodyCardsRiddles.vue?vue&type=script&lang=js&"
import style0 from "./c_Creator_EditQuests_Item_BodyCardsRiddles.vue?vue&type=style&index=0&id=5ec897ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec897ff",
  null
  
)

export default component.exports